// The ribbon-O mark (D/brand/econic-mark.svg) in a navy disc with a hairline (no gold ring, §00.6): the ECONIC Agent's avatar and
// "built with ECONIC" stamps (DESIGN-SYSTEM §9, §10.15). Round, as an avatar (§00.1). Minimum 12 px; the agent uses 24 (thread), 30 (sidebar header and rail), 16 (phone context line).
import type { CSSProperties, HTMLAttributes } from "react";
import { BRAND } from "./names";

export interface EconicMarkProps extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  size?: number;
  /** Accessible name when the mark stands alone (e.g. "ECONIC Agent"); decorative otherwise. */
  label?: string;
}

export function EconicMark({ size = 24, label, className, style, ...rest }: EconicMarkProps) {
  const vars = { "--ec-mark": `${Math.max(12, size)}px`, ...style } as CSSProperties;
  return (
    <span
      className={className ? `ec-agent-mark ${className}` : "ec-agent-mark"}
      style={vars}
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
      {...rest}
    >
      <img src={BRAND.mark} alt="" draggable={false} decoding="async" />
    </span>
  );
}
